import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '../Button';
import Dialog from '../Dialog';
import DialogContent from '../DialogContent';
import DialogActions from '../DialogActions';

const S = {
  Dialog: styled(Dialog)`
    .paper {
      min-width: 480px;
    }
  `,
  DialogContent: styled(DialogContent)`
    margin-bottom: 2.5rem;
  `,
  RetryButton: styled(Button)`
    border-color: ${({ theme }) => theme.palette.error.main};
    color: ${({ theme }) => theme.palette.error.main};
    :focus, :hover {
      background-color: ${({ theme }) => theme.palette.hexToRgb(theme.palette.error.main, 0.08)};
    }
  `,
};

const RetryDialog = ({
  children, open, onClose, onRetry, ...otherProps
}) => (
  <S.Dialog open={open} onClose={onClose} {...otherProps}>
    <S.DialogContent>
      {children}
    </S.DialogContent>
    <DialogActions>
      {onClose && <Button type="button" variant="outlined" onClick={onClose}>닫기</Button>}
      {onRetry && <S.RetryButton type="button" variant="outlined" onClick={onRetry}>재시도</S.RetryButton>}
    </DialogActions>
  </S.Dialog>
);

RetryDialog.propTypes = {
  children: PropTypes.node.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onRetry: PropTypes.func,
};

RetryDialog.defaultProps = {
  onClose: undefined,
  onRetry: undefined,
};

export default RetryDialog;
